// extracted by mini-css-extract-plugin
export default {"deprecatedHistory":"EkR5WHuaRrvMMdU7bawx"};